webpackJsonp([50828431127232],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colors = ['primary', 'secondary', 'dark', 'danger', 'warning', 'info', 'accent', 'success'];
	var pageSize = 10;
	
	var PortfolioPage = function (_React$Component) {
	  _inherits(PortfolioPage, _React$Component);
	
	  function PortfolioPage(props) {
	    _classCallCheck(this, PortfolioPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var posts = _this.props.data.allMarkdownRemark.edges.filter(function (post) {
	      return post.node.frontmatter.templateKey === 'portfolio-post';
	    });
	    var tagColors = {};
	    var tags = [];
	
	    posts.forEach(function (post) {
	      if (post.node.frontmatter.tags && post.node.frontmatter.tags.length) {
	        tags = tags.concat(post.node.frontmatter.tags);
	      }
	    });
	
	    // Remove duplicates.
	    tags.filter(function (el, i, a) {
	      return i === a.indexOf(el);
	    }).forEach(function (tag, i) {
	      if (i >= colors.length) {
	        i = 0;
	      }
	
	      tagColors[tag.toUpperCase()] = colors[i];
	    });
	
	    _this.state = {
	      posts: posts,
	      original: posts,
	      tagColors: tagColors,
	      pageSize: pageSize,
	      diff: posts.length - pageSize
	    };
	    return _this;
	  }
	
	  PortfolioPage.prototype.filterList = function filterList(event) {
	    var posts = event.target.value ? this.state.original.filter(function (item) {
	      return JSON.stringify(item).toLowerCase().includes(event.target.value);
	    }) : this.state.original;
	
	    this.setState({ posts: posts });
	  };
	
	  PortfolioPage.prototype.showAll = function showAll() {
	    this.setState({ pageSize: 0, hideMoreBtn: true });
	  };
	
	  PortfolioPage.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'section page page-no-padding portfolio-page' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'fancy' },
	              'Recent Projects'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-lg pull-right' },
	              _react2.default.createElement('input', { onChange: this.filterList.bind(this), type: 'text', className: 'form-control', 'aria-label': 'Large', placeholder: 'Search...', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group-prepend' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-lg' },
	                  _react2.default.createElement('i', { className: 'fa fa-search', 'aria-hidden': 'true' })
	                )
	              )
	            )
	          )
	        ),
	        this.state.posts.slice(0, this.state.pageSize ? this.state.pageSize : this.state.posts.length).map(function (item, index) {
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: item.node.frontmatter.path, className: 'project well animate fade-in', key: item.node.id },
	            _react2.default.createElement('img', { className: 'border-left w-300', src: item.node.frontmatter.thumbnail, alt: 'Project Thumbnail' }),
	            _react2.default.createElement(
	              'div',
	              { 'class': 'section-header' },
	              _react2.default.createElement(
	                'span',
	                { className: 'badge badge-light badge-date text-muted pull-right' },
	                item.node.frontmatter.date
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                item.node.frontmatter.title
	              )
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              _react2.default.createElement(
	                'small',
	                null,
	                item.node.frontmatter.description
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              item.node.excerpt,
	              ' ',
	              _react2.default.createElement(
	                'i',
	                { className: 'text-primary', href: true, to: item.node.frontmatter.path },
	                'read more ',
	                _react2.default.createElement('i', { className: 'fa fa-chevron-circle-right' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'project-footer' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tags' },
	                item.node.frontmatter.tags && item.node.frontmatter.tags.map(function (tag) {
	                  return _react2.default.createElement(
	                    'span',
	                    { key: tag, className: 'badge badge-' + (_this2.state.tagColors[tag.toUpperCase()] || 'primary') },
	                    tag.toUpperCase()
	                  );
	                })
	              )
	            )
	          );
	        })
	      ),
	      !this.state.hideMoreBtn && this.state.diff && _react2.default.createElement(
	        'div',
	        { className: 'container text-center cushy-top' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-lg btn-secondary', onClick: this.showAll.bind(this) },
	          _react2.default.createElement('i', { className: 'fa fa-plus', 'aria-hidden': 'true' }),
	          ' View ',
	          this.state.diff,
	          ' More Projects'
	        )
	      )
	    );
	  };
	
	  return PortfolioPage;
	}(_react2.default.Component);
	
	exports.default = PortfolioPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-portfolio-page-js-2fc58864b46def3926be.js